import {
  GroupMonitoringAuditResponse,
  GroupMonitoringDetailResponse,
  GroupMonitoringGroupsResponse,
  GroupMonitoringOptionsResponse,
  GroupMonitoringPartnersResponse,
  GroupMonitoringProductsResponse,
  GroupMonitoringQuery,
  GroupMonitoringSummary,
  DeleteEmptyGroupsResult,
  RecomputeAgeGapsResult,
  PruneStaleGroupMembersResult,
  GroupMonitoringUnassignedEnrollmentsResponse,
  EnrollmentSourceDetail,
  ReprocessAssignmentGapRequest,
  ReprocessAssignmentGapResponse,
} from '@models/group-monitoring';
import { apiClient } from '.';

const BASE_URL = '/admin/v1/group-monitoring';

export const getGroupMonitoringSummary = async (params?: GroupMonitoringQuery) => {
  return apiClient.get<GroupMonitoringSummary>(`${BASE_URL}/summary`, { params });
};

export const getGroupMonitoringPartners = async (params?: GroupMonitoringQuery) => {
  return apiClient.get<GroupMonitoringPartnersResponse>(`${BASE_URL}/partners`, { params });
};

export const getGroupMonitoringProducts = async (params?: GroupMonitoringQuery) => {
  return apiClient.get<GroupMonitoringProductsResponse>(`${BASE_URL}/products`, { params });
};

export const getGroupMonitoringOptions = async (params?: GroupMonitoringQuery) => {
  return apiClient.get<GroupMonitoringOptionsResponse>(`${BASE_URL}/options`, { params });
};

export const getGroupMonitoringUnassignedEnrollments = async (params?: GroupMonitoringQuery) => {
  return apiClient.get<GroupMonitoringUnassignedEnrollmentsResponse>(`${BASE_URL}/unassigned-enrollments`, {
    params,
  });
};

export const getGroupMonitoringGroups = async (params?: GroupMonitoringQuery) => {
  return apiClient.get<GroupMonitoringGroupsResponse>(`${BASE_URL}/groups`, { params });
};

export const getGroupMonitoringGroupDetail = async (groupId: string) => {
  return apiClient.get<GroupMonitoringDetailResponse>(`${BASE_URL}/groups/${groupId}`);
};

export const getGroupMonitoringAudit = async (params?: GroupMonitoringQuery) => {
  return apiClient.get<GroupMonitoringAuditResponse>(`${BASE_URL}/audit`, { params });
};

export const getGroupMonitoringEnrollmentSource = async (scheduleId: string) => {
  return apiClient.get<EnrollmentSourceDetail>(`${BASE_URL}/enrollments/${scheduleId}/source`);
};

export const pruneStaleGroupMembers = async (params?: GroupMonitoringQuery) => {
  return apiClient.post<PruneStaleGroupMembersResult>(`${BASE_URL}/prune-stale-members`, null, { params });
};

export const deleteEmptyGroups = async (params?: GroupMonitoringQuery) => {
  return apiClient.post<DeleteEmptyGroupsResult>(`${BASE_URL}/delete-empty-groups`, null, { params });
};

export const recomputeAgeGaps = async (params?: GroupMonitoringQuery) => {
  return apiClient.post<RecomputeAgeGapsResult>(`${BASE_URL}/recompute-age-gaps`, null, { params });
};

export const reprocessGroupMonitoringAssignmentGap = async (body: ReprocessAssignmentGapRequest) => {
  return apiClient.post<ReprocessAssignmentGapResponse>(`${BASE_URL}/options/reprocess-assignment-gap`, body);
};
